(function () {
  var MIN_WIDTH = 900;
  var HOTSPOT_X = 23;
  var HOTSPOT_Y = 6;

  function isEnabled() {
    return (
      window.matchMedia('(min-width: ' + MIN_WIDTH + 'px)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function updateEnabledState(cursor) {
    if (!isEnabled()) {
      document.body.classList.remove('wandcursor');
      cursor.hidden = true;
      return false;
    }

    document.body.classList.add('wandcursor');
    cursor.hidden = false;
    return true;
  }

  function initWandCursor() {
    var cursor = document.querySelector('[data-hp-wand-cursor]');
    if (!cursor) return;

    if (cursor.parentElement !== document.body) {
      document.body.appendChild(cursor);
    }

    if (cursor.dataset.initialized === 'true') {
      updateEnabledState(cursor);
      return;
    }

    if (!updateEnabledState(cursor)) return;

    cursor.dataset.initialized = 'true';

    var visible = false;
    var lastSpark = 0;

    function moveTo(clientX, clientY) {
      cursor.style.transform =
        'translate3d(' + (clientX - HOTSPOT_X) + 'px,' + (clientY - HOTSPOT_Y) + 'px,0)';
    }

    function spawnSpark(clientX, clientY) {
      var now = performance.now();
      if (now - lastSpark <= 24 || Math.random() <= 0.4) return;

      lastSpark = now;

      var spark = document.createElement('div');
      var size = 3 + Math.random() * 5;
      var x = clientX + Math.random() * 10 - 5;
      var y = clientY + Math.random() * 10 - 5;
      var color = Math.random() > 0.5 ? '#F9E78D' : '#CA9E48';

      spark.className = 'hp-wizard-wand-spark';
      spark.setAttribute('aria-hidden', 'true');
      spark.style.cssText =
        'position:fixed;' +
        'pointer-events:none;' +
        'z-index:1000001;' +
        'display:block;' +
        'border-radius:50%;' +
        'width:' +
        size +
        'px;' +
        'height:' +
        size +
        'px;' +
        'left:' +
        x +
        'px;' +
        'top:' +
        y +
        'px;' +
        'background:' +
        color +
        ';' +
        'box-shadow:0 0 8px #CA9E48,0 0 14px rgba(249,231,141,0.45);' +
        'opacity:1;' +
        'animation:hp-wizard-wand-spark-fade .6s ease-out forwards;';

      document.body.appendChild(spark);

      setTimeout(function () {
        spark.remove();
      }, 600);
    }

    function show() {
      cursor.style.opacity = '1';
      visible = true;
    }

    function hide() {
      cursor.style.opacity = '0';
      visible = false;
    }

    function isOverPrivacyUi(event) {
      if (event.composedPath) {
        return event.composedPath().some(function (el) {
          return el && el.id && el.id.indexOf('shopify-pc__') === 0;
        });
      }

      return event.target && event.target.closest && event.target.closest('[id^="shopify-pc__"]');
    }

    document.addEventListener('mousemove', function (event) {
      moveTo(event.clientX, event.clientY);

      if (isOverPrivacyUi(event)) {
        hide();
        return;
      }

      if (!visible) show();

      spawnSpark(event.clientX, event.clientY);
    });

    document.addEventListener('mouseleave', hide);

    window.addEventListener(
      'blur',
      function () {
        hide();
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWandCursor);
  } else {
    initWandCursor();
  }

  document.addEventListener('shopify:section:load', initWandCursor);

  window.addEventListener(
    'resize',
    function () {
      initWandCursor();
    },
    { passive: true }
  );
})();
